<template>
    <div id="Preferential">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">
                特惠推荐
            </div>
            <div slot="right">
                <van-icon name="shopping-cart" @click.stop="showCart" size="30" color="#1989fa" />
            </div>
        </nav-bar>
        <div class="pre-introduce">
            <span>我猜得到 你的需要</span>
            <span>给你贴心的日用好物</span>
        </div>
        <div style="background-color: white; height: 20px"></div>
        <div class="pre-title">
            <span>今日特惠</span>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-card
                        :id="item.id"
                        :price="item.price"
                        :desc="item.desc"
                        :title="item.title"
                        :thumb="item.thumb"
                        v-for="(item, index) of goodsList"
                        @click="toGoodsList(item.id)"
                />
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import { Icon, PullRefresh, List, Card, Toast } from 'vant';
    import NavBar from "../../components/common/navbar/NavBar";
    export default {
        name: "Preferential",
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            [Card.name]: Card,
            [Toast.name]: Toast
        },
        data(){
            return{
                loading: false,
                finished: false,
                refreshing: false,
                goodsList: [],
            }
        },
        methods: {
            goBack() {
                this.$route.meta.keepAlive = false
                this.$router.back(-1);
            },
            showCart() {
                this.$router.push({path: '/order/shoppingCart'})
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
            onLoad() {
                setTimeout(()=>{
                    if(this.refreshing){
                        this.refreshing = false;
                        this.goodsList = [
                            {
                                id: 1,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 2,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 3,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 4,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 5,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 6,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 7,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 9,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 10,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                        ];
                        this.loading = false;
                    }else {
                        this.goodsList.push(
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            },
                            {
                                id: 8,
                                price: 99.99,
                                desc: '红色/至尊',
                                title: '小米',
                                thumb: 'https://img.yzcdn.cn/vant/ipad.jpeg'
                            }
                        )
                        this.loading = false;
                        // Toast('上拉加载');
                    }
                },1000)
            },
            toGoodsList(id) {
                this.$router.push({path: '/goods/goodsInfo/'+ id})
            }
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #efefef;
    }

    .pre-introduce {
        height: 110px;
        margin-top: 46px;
        background-color: #ccc;
        text-align: center;
    }
    .pre-introduce span {
        color: white;
        font-size: 18px;
        display: block;
        margin-top: 10px;
    }

    .pre-introduce span:first-child {
        font-weight: 700;
        padding-top: 20px;
        font-size: 20px;
    }

    .pre-title {
        font-size: 16px;
        height: 40px;
        border-bottom: 1px solid #cccccc;
        border-top: 1px solid #cccccc;
        line-height: 40px;
        background-color: white;
    }

    .pre-title span {
        padding-left: 20px;
    }

    ::v-deep .van-card{
        margin-top: 0px;
    }

    ::v-deep .van-card {
        border-bottom: 1px solid #ccc;
    }
</style>